exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\n\r\n.active{\r\n    background: grey !important;\r\n    color: white !important;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./src/styles.css
// module id = 460
// module chunks = 2